export const ActionTypes = {
  LOADING: "ADD_TO_SHORTLIST_LOADING",
  ERROR: "ADD_TO_SHORTLIST_ERROR",
  SUCCESS: "ADD_TO_SHORTLIST_SUCCESS",
};
